<script>
	import { fly } from "svelte/transition";
	export let toggleDetails;
</script>

<div
	class="sidebar-popup"
	in:fly={{ x: 300, duration: 250 }}
	out:fly={{ x: 300, duration: 250 }}
>
	<div class="d-flex justify-content-end my-3">
		<button class="close-btn" on:click={() => toggleDetails()}>X</button>
	</div>
	<slot />
</div>
<div
	class="overlay"
	on:click={() => toggleDetails()}
	on:keydown={(e) => e.key === "Enter" && toggleDetails()}
/>

<style>
	.sidebar-popup {
		position: fixed;
		top: 0;
		right: 0;
		width: 500px;
		height: 100%;
		background-color: white;
		padding: 0 20px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
		overflow-y: auto;
		z-index: 100;
	}

	.close-btn {
		background: none;
		border: none;
		cursor: pointer;
	}

	.overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 70%;
		height: 100%;
		z-index: 0;
	}
</style>
